<template>
  <div class='text-center m-4'>
    <h4>{{code}}</h4>
    <p v-if="code == 404">This page does not exist</p>
    <p v-else>An error occured</p>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: ['code']
}
</script>

<style scoped>

</style>
